import { useEffect } from 'react'
import App from 'antd/es/app'

import { setAntdStaticsBridge } from './index'

/**
 * Publishes `App.useApp()`'s `message`/`notification` instances to the
 * `src/ui/toast` proxy, so every existing `message.success(...)` /
 * `notification.open(...)` call site starts rendering inside the app's
 * `ConfigProvider` (Geist, dark theme) instead of antd's detached static
 * root. See the long comment in `src/ui/toast/index.ts`.
 *
 * Must be mounted as a descendant of the `<App>` from `antd/es/app` that
 * `AntdI18n` renders. Outside one, `App.useApp()` does NOT throw — it reads
 * antd's default context value and silently returns empty, method-less
 * `message`/`notification` objects, which is why the proxy in
 * `src/ui/toast/index.ts` falls through to the plain antd static for any
 * method a published instance does not have. Renders nothing.
 */
export const AntdStaticsBridge = (): null => {
  const { message, notification } = App.useApp()

  useEffect(() => {
    setAntdStaticsBridge({ message, notification })
    return () => setAntdStaticsBridge(null)
  }, [message, notification])

  return null
}
